import React from "react";
import {
  ProfilePage,
  ProfileSettings,
  ProfileTabDataMobileFetcher,
} from "../../../src/features/profile/index";
import { siteRoutes } from "../siteRoutesList";

export const profileRoutes = [
  {
    element: () => ProfilePage({ belongToCurrentUser: true }),
    path: siteRoutes["profile"], // route to self profile
  },
  {
    element: ProfilePage,
    path: `${siteRoutes["profileAndSlug"]}:slug`, // route to other user's profile
  },
  {
    element: ProfileSettings,
    path: siteRoutes["profileSettings"], // route to other user's profile
  },
  {
    element: ProfileTabDataMobileFetcher,
    path: `${siteRoutes["profileTabAndSlug"]}:slug`, // route to other user's profile
  },
];
